import classNames from 'classnames';
import type { Op } from 'quill/core';
import React, { useState } from 'react';
import * as styles from './ReadonlyOrganizationSummary.module.scss';
import useAppSelector, { useAppDispatch } from '../../app/redux/useAppSelector';
import { MenuItem } from '../../components/Menu';
import OverflowMenu from '../../components/OverflowMenu';
import SummaryCollapsibleContent from '../../components/SummaryCollapsibleContent';
import editIcon from '../../icons/non-prefilled/16x16/editPost.svg';
import { UIActions } from '../../ui/uiSlice';

interface ReadonlyOrganizationSummaryProps {
  summary: Op[] | null;
  onStartEditing: () => void;
}

const ReadonlyOrganizationSummary = ({
  summary,
  onStartEditing,
}: ReadonlyOrganizationSummaryProps) => {
  const [isOverflowMenuOpen, setIsOverflowMenuOpen] = useState(false);

  const dispatch = useAppDispatch();
  const isAdmin = useAppSelector(
    (state) => state.session.user.type === 'ADMIN',
  );
  const isCollapsed = useAppSelector(
    (state) => state.ui.isOrganizationSummaryCollapsed,
  );

  return (
    <div className={styles.container}>
      {summary ? (
        <SummaryCollapsibleContent
          collapsed={isCollapsed}
          onCollapsedChange={(newCollapsed) => {
            dispatch(
              UIActions.toggleOrganizationSummaryCollapsed(newCollapsed),
            );
          }}
          maxLines={7}
          typography="post"
          content={summary}
        />
      ) : (
        <div className={styles.header}>
          <h1>Home</h1>
        </div>
      )}
      {isAdmin && (
        <div
          className={classNames(styles.overflowMenu, {
            [styles.open]: isOverflowMenuOpen,
          })}
        >
          <OverflowMenu
            open={isOverflowMenuOpen}
            onOpenChange={setIsOverflowMenuOpen}
          >
            <MenuItem icon={editIcon} onClick={onStartEditing}>
              Edit description
            </MenuItem>
          </OverflowMenu>
        </div>
      )}
    </div>
  );
};

export default ReadonlyOrganizationSummary;
